import { render, staticRenderFns } from "./AiInfo.vue?vue&type=template&id=571b5f52&scoped=true"
import script from "./AiInfo.vue?vue&type=script&lang=js"
export * from "./AiInfo.vue?vue&type=script&lang=js"
import style0 from "./AiInfo.vue?vue&type=style&index=0&id=571b5f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b5f52",
  null
  
)

export default component.exports